import React from "react";
import './reserve.css'
import Modal from "./Modal";

const stylenews = {
     marginLeft: "40px",
    marginRight: "40px",
  padding:0
}
const stylepadb20 = {
    paddingBottom: "20px"
}
export default function Blog() {
    document.getElementById("map").style.display = "none"
    const Read = () => {
        
    }
    return (
        <>
            <Modal/>
            <div className="row" style={stylenews}>
                <div className="col-sm-8">
                    <div id="blogtitle">Банкротство физических лиц</div>
                    <img width="730px" src="../images/blog.png" />
                    <div id="newsfirst">В частности, консультация с широким активом позволяет выполнить важные задания по разработке распределения внутренних резервов и ресурсов. В своём стремлении улучшить пользовательский опыт мы упускаем, что некоторые особенности внутренней политики лишь добавляют фракционных разногласий и рассмотрены исключительно в разрезе маркетинговых и финансовых предпосылок.</div>
                    <div className="orangebtn" id="read" onClick={Read}>Читать</div>

                     <div id="blogtitle">Банкротство физических лиц</div>
                    <img width="730px" src="../images/blog.png" />
                    <div id="newsfirst">В частности, консультация с широким активом позволяет выполнить важные задания по разработке распределения внутренних резервов и ресурсов. В своём стремлении улучшить пользовательский опыт мы упускаем, что некоторые особенности внутренней политики лишь добавляют фракционных разногласий и рассмотрены исключительно в разрезе маркетинговых и финансовых предпосылок.</div>
                    <div className="orangebtn" id="read" onClick={Read}>Читать</div>

                    <div id="space"/>
                </div>
                <div className="col-sm-4" id="seachform">
                    <input id="searchinput" placeholder="Поиск" />
                    <img id="play" src="../images/playgray.png"/>
                    <div id="rightside">
                        <div id="category">
                            <div className="col-sm margpadlr" id="catmain">Категории</div>
                            <div className="container-fluid margpadlr">
                                <div className="row searchactiv" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                             <div className="container-fluid margpadlr">
                                <div className="row" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                            <div className="container-fluid margpadlr">
                                <div className="row" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                            <div className="container-fluid margpadlr">
                                <div className="row" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                            <div className="container-fluid margpadlr">
                                <div className="row" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                            <div className="container-fluid margpadlr">
                                <div className="row" id="searchrow">
                                    <div className="col-sm margpadlr">Банкротство</div>
                                    <div className="col-sm margpadlr text-right" id="searchvolume">20 записей</div>
                                </div>
                            </div>
                        </div>
                        <div className="row" id="news">
                        <div className="col-sm margpadlr" id="newsmain">Последние новости</div>
                            <div className="row newsrow" style={stylepadb20 }>
                                <div className="col-sm margpadlr" id="newspic"><img width="111px" src="../images/blog.png"/></div>
                                <div className="col-sm margpadlr" id="newstext">
                                <div id="newstitle">Банкротство физических лиц</div>
                                <div id="newsdate">50 мая, 2021</div>
                                </div>
                            </div>
                            <div className="row newsrow" style={stylepadb20 }>
                                <div className="col-sm margpadlr" id="newspic"><img width="111px" src="../images/blog.png"/></div>
                                <div className="col-sm margpadlr" id="newstext">
                                <div id="newstitle">Банкротство физических лиц</div>
                                <div id="newsdate">50 мая, 2021</div>
                                </div>
                            </div>
                            <div className="row newsrow" style={stylepadb20 }>
                                <div className="col-sm margpadlr" id="newspic"><img width="111px" src="../images/blog.png"/></div>
                                <div className="col-sm margpadlr" id="newstext">
                                <div id="newstitle">Банкротство физических лиц</div>
                                <div id="newsdate">50 мая, 2021</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        </>
    )
}